import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { EndPointService } from 'src/app/core/services/end-point.service';
import { PagingState } from 'src/app/shared/framework/paging/PagingState';

import { Course } from 'src/app/modules/lms/learningpaths/models/Course';
import { IActiveCourse, ICourseHistory, ICourseRequestWrapper, ISpotlightCourse } from '../models/CourseWidgetWrapper';

@Injectable({
  providedIn: 'root'
})
export class CourseWidgetsService {

  private _apiBase = '/api/lms/courses/';

  private _essWidgetsActive = 'ess/widgetactive';
  private _essWidgetsRequests = 'ess/widgetrequests';
  private _essWidgetsHistory = 'ess/widgethistory';
  private _essWidgetsSpotlight = 'ess/widgetspotlight';

  constructor(private _endPointService: EndPointService, private http: HttpClient) {
    this.registerEndPoints();
  }

  //#region register endpoints
  private registerEndPoints(): void {
    this._endPointService.registerEndPoint<IActiveCourse[]>(
      'ess_widgetactive',
      `${this._apiBase}${this._essWidgetsActive}`
    );
    this._endPointService.registerEndPoint<ICourseRequestWrapper>(
      'ess_widgetrequests',
      `${this._apiBase}${this._essWidgetsRequests}`
    );
    this._endPointService.registerEndPoint<ICourseHistory>(
      'ess_widgethistory',
      `${this._apiBase}${this._essWidgetsHistory}`
    );

    this._endPointService.registerEndPoint<ISpotlightCourse[]>(
      'ess_widgetspotlight',
      `${this._apiBase}${this._essWidgetsSpotlight}`
    );

    this._endPointService.registerEndPoint<Course[]>('all_courses', `/api/lms/training/getAll`);
    this._endPointService.registerEndPoint<number>('count_courses', `/api/lms/training/count`);

  }
  //#endregion

  public getWidgetActive(fetch?: boolean): Observable<IActiveCourse[]> {
    return this._endPointService.call<IActiveCourse[]>('ess_widgetactive', null, fetch);
  }

  public getWidgetRequests(fetch?: boolean): Observable<ICourseRequestWrapper> {
    return this._endPointService.call<ICourseRequestWrapper>('ess_widgetrequests', null, fetch);
  }

  public getWidgetHistory(fetch?: boolean): Observable<ICourseHistory> {
    return this._endPointService.call<ICourseHistory>('ess_widgethistory', null, fetch);
  }

  public getWidgetSpotlight(fetch?: boolean): Observable<ISpotlightCourse[]> {
    return this._endPointService.call<ISpotlightCourse[]>('ess_widgetspotlight', null, fetch);
  }


  public getCourses(paging: PagingState): Observable<Course[]> {
    return this._endPointService.call<Course[]>('all_courses', paging);
  }

  public countAllCourses(paging: PagingState): Observable<number> {
    return this._endPointService.call<number>('count_courses', paging);
  }
}
